export const CREATE_HSNCODE  = 'CREATE_HSNCODE';
export const GET_HSNCODE  = 'GET_HSNCODE';
export const HSNCODE_REQUEST  = 'HSNCODE_REQUEST';
export const DELETE_HSNCODE  = 'DELETE_HSNCODE';
export const UPDATE_HSNCODE  = 'UPDATE_HSNCODE';
export const HSNCODE_REQUEST_FAILURE  = 'HSNCODE_REQUEST_FAILURE';